import { StateCreator } from 'zustand';
import { Store } from 'store';
import { EFavoritesType } from 'lib/types';
import { MarketTypes } from 'api/types';

export interface FavoriteSlice {
  favoriteListTypeSelected: { Primary: EFavoritesType; Secondary: EFavoritesType };
  setFavoriteListTypeSelected: (typeFavorite: EFavoritesType, typeFacility: MarketTypes) => void;

  favoriteListIdSelected: { Primary: number | undefined; Secondary: number | undefined };
  setFavoriteListIdSelected: (favoriteListId: number, typeFacility: MarketTypes) => void;

  favoriteMTypeByFavTypeListSelected: {
    [EFavoritesType.Customer]: MarketTypes;
    [EFavoritesType.Personal]: MarketTypes;
    [EFavoritesType.Shared]: MarketTypes;
  };
  setFavoriteMTypeByFavTypeListSelected: (
    favoriteType: EFavoritesType,
    marketType: MarketTypes,
  ) => void;

  favoriteSearchByFavTypeListSelected: {
    [EFavoritesType.Customer]: string;
    [EFavoritesType.Personal]: string;
    [EFavoritesType.Shared]: string;
  };
  setFavoriteSearchByFavTypeListSelected: (favoriteType: EFavoritesType, search: string) => void;
}

const createFavoriteSlice: StateCreator<Store, [['zustand/immer', never]], [], FavoriteSlice> = (
  set,
  get,
) => ({
  favoriteListTypeSelected: {
    Primary: EFavoritesType.Personal,
    Secondary: EFavoritesType.Personal,
  },
  setFavoriteListTypeSelected: (newTypeFavorite, typeFacility) =>
    set((value) => {
      const isSecondary = typeFacility === MarketTypes.SECONDARY;

      const Primary = isSecondary ? value.favoriteListTypeSelected?.Primary : newTypeFavorite;
      const Secondary = isSecondary ? newTypeFavorite : value.favoriteListTypeSelected?.Secondary;

      return { favoriteListTypeSelected: { Primary, Secondary } };
    }),

  favoriteListIdSelected: {
    Primary: undefined,
    Secondary: undefined,
  },
  setFavoriteListIdSelected: (favoriteListId, typeFacility) =>
    set((value) => {
      const isSecondary = typeFacility === MarketTypes.SECONDARY;

      const Primary = isSecondary ? value.favoriteListIdSelected?.Primary : favoriteListId;
      const Secondary = isSecondary ? favoriteListId : value.favoriteListIdSelected?.Secondary;

      return { favoriteListIdSelected: { Primary, Secondary } };
    }),

  favoriteMTypeByFavTypeListSelected: {
    [EFavoritesType.Customer]: MarketTypes.SECONDARY,
    [EFavoritesType.Personal]: MarketTypes.SECONDARY,
    [EFavoritesType.Shared]: MarketTypes.SECONDARY,
  },

  setFavoriteMTypeByFavTypeListSelected: (favoriteType, marketType) =>
    set((value) => {
      return {
        favoriteMTypeByFavTypeListSelected: {
          ...value.favoriteMTypeByFavTypeListSelected,
          [favoriteType]: marketType,
        },
      };
    }),

  favoriteSearchByFavTypeListSelected: {
    [EFavoritesType.Customer]: '',
    [EFavoritesType.Personal]: '',
    [EFavoritesType.Shared]: '',
  },

  setFavoriteSearchByFavTypeListSelected: (favoriteType, search) =>
    set((value) => {
      return {
        favoriteSearchByFavTypeListSelected: {
          ...value.favoriteSearchByFavTypeListSelected,
          [favoriteType]: search,
        },
      };
    }),
});

export default createFavoriteSlice;
